import '../css/z_category.less';
import pagination from '../../libs/pagination/pagination';
import banner from '../../libs/banner/banner';
import '../css/list.less';

// banner
banner.render({ bannerWidth: 1920, bannerHeight: 420 });
pagination.render();

// 加载更多
$(function () {
    $(document).on("click", ".mu8-loadmore-list", function () {
        var that = this;
        var page = parseInt($(this).data("page"));
        page++;
        $(that).prop("disabled", true);
        $.ajax({
            url: location.pathname + $(that).data("href"),
            type: "post",
            success: function (res) {
                console.log(res.data);
                $('.mu8-main-content').append(res.data);
                $(that).parent().remove();
                return false;
            },
        });
        return false;
    })
});